import { defaultSmsConfigState } from "../const";

const smsConfigAction = {
  initializeState: 'INITIALIZE_STATE',
  changeName: 'CHANGE_NAME',
  changeTwilioAccountSid: 'CHANGE_TWILIO_ACCOUNT_SID',
  changeTwilioAuthToken: 'CHANGE_TWILIO_AUTH_TOKEn',
  changeTwilioFromNumber: 'CHANGE_TWILIO_FROM_NUMBER',
  changeResendAfter: 'CHANGE_RESEND_AFTER',
  changeMaximumResend: 'CHANGE_MAXIMUM_RESEND',
  changeMaximumRequest: 'CHANGE_MAXIMUM_REQUEST',
  changeDenialPeriod: 'CHANGE_DENIAL_PERIOD',
  changeOtpExpiresIn: 'CHANGE_OTP_EXPIRES_IN',
  changeAllowedPhonePrefix: 'CHANGE_ALLOWED_PHONE_PREFIX',
  changeAccessLevel: 'CHANGE_ACCESS_LEVEL',
  changeSiteTagOrSite: 'CHANGE_SITE_TAG_OR_SITE'
}

const smsConfigReducer = (state, action) => {
  switch (action.type) {
    case smsConfigAction.initializeState:
      return {
        ...state,
        ...action.payload
      };
    case smsConfigAction.changeName:
      return {
        ...state,
        name: action.payload
      };
    case smsConfigAction.changeTwilioAccountSid:
      return {
        ...state,
        twilioAccountSid: action.payload
      };
    case smsConfigAction.changeTwilioAuthToken:
      return {
        ...state,
        twilioAuthToken: action.payload
      };
    case smsConfigAction.changeTwilioFromNumber:
      return {
        ...state,
        twilioFromNumber: action.payload
      };
    case smsConfigAction.changeResendAfter:
      return {
        ...state,
        resendAfter: action.payload
      };
    case smsConfigAction.changeMaximumResend:
      return {
        ...state,
        maximumResend: action.payload
      };
    case smsConfigAction.changeMaximumRequest:
      return {
        ...state,
        maximumRequest: action.payload
      };
    case smsConfigAction.changeDenialPeriod:
      return {
        ...state,
        denialPeriod: action.payload
      };
    case smsConfigAction.changeOtpExpiresIn:
      return {
        ...state,
        otpExpiresIn: action.payload
      };
    case smsConfigAction.changeAllowedPhonePrefix:
      return {
        ...state,
        allowedPhonePrefix: action.payload
      };
    case smsConfigAction.changeAccessLevel:
      return {
        ...state,
        accessLevel: action.payload
      };
    case smsConfigAction.changeSiteTagOrSite:
      return {
        ...state,
        siteTagOrSite: action.payload
      };
    default:
      return defaultSmsConfigState;
  }
};

export default {
  defaultState: defaultSmsConfigState,
  action: smsConfigAction,
  reducer: smsConfigReducer
}